import React from 'react'

export const Footer = () => {
    return (
        <div>
            <p className='footer'>&copy; 2025, Emma Lebedeva</p>
        </div>
    )
}
